import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { ReviewType } from "src/api/types";
import WhiteCard from "src/shared/components/WhiteCard";

interface Props {
  review: ReviewType;
  width?: number | string;
  onNext?: () => void;
}

const Review = ({ review, width, onNext }: Props) => {
  const page = "reviews";
  const { t } = useTranslation();

  return (
    <WhiteCard
      key={review.name}
      sx={{ background: "#E6FFFF" }}
      gap={1}
      width={width}
      onClick={onNext}
    >
      <Stack direction="row" gap={1} alignItems="center">
        <Avatar src={review.image} alt="Reviewer" />
        <Stack>
          <Typography fontWeight={600}>{review.name}</Typography>
          <Typography>{review.location}</Typography>
        </Stack>
      </Stack>

      <Typography>{t(`${page}.${review.id}.text`, review.text)}</Typography>
      <Typography fontSize="18px">⭐⭐⭐⭐⭐</Typography>
    </WhiteCard>
  );
};

export default Review;
